export const splitArray = (arr: any[], chunkSize = 1) => {
  if (Array.isArray(arr) === false) return [];
  return [].concat.apply(
    [],
    arr.map(function (elem, i) {
      return i % chunkSize ? [] : [arr.slice(i, i + chunkSize)];
    })
  );
};
